<template>
    <div id="cs">
        <b-form @input="onInput">
            <b-form-group
                    id="input-group-1"
            >
                <b-form-input
                        id="input-1"
                        v-model="commit"
                        required
                        placeholder="SHA"
                ></b-form-input>
            </b-form-group>
        </b-form>
        <div class="text-center" v-if="loading">
            <b-spinner label="Searching..."></b-spinner>
            <br>
            {{this.operation}}
        </div>
        <b-alert v-model="errored" :variant="errorvar">
            {{this.errormsg}}
        </b-alert>
        <b-card v-if="results && results.data.upstream && !loading && results.data.included">
            <b-card-text>
                {{this.results.data.upstream}}
                <b-badge variant="success" v-for="ver in results.data.included" :key="ver" pill>{{ver}}</b-badge>
            </b-card-text>
        </b-card>
    </div>

</template>

<script>
    import {isUndefinedOrNullOrEmpty} from "bootstrap-vue/src/utils/inspect";

    export default {
        name: "search",
        data() {
            return {
                commit: "",
                results: null,
                loading: false,
                errored: false,
                errormsg: "",
                errorvar: "",
                operation: ""
            }
        },
        methods: {
            onInput(evt) {
                evt.preventDefault()
                if (!isUndefinedOrNullOrEmpty(this.commit) && this.commit.length > 6) {
                    this.loading = true
                    this.errored = false
                    this.operation = "Making sure we have the latest data..."

                    this.axios.get('https://api.cinlin.io/update')
                        .then(response => {
                            if (response.data.last_update) {
                                this.operation = "Searching backports..."

                                this.axios.get('https://api.cinlin.io/search/' + encodeURIComponent(this.commit))
                                    .then(response => {
                                        this.results = response
                                        this.loading = false

                                        if (!this.results.data.upstream) {
                                            this.errormsg = "No upstream kernel commit found"
                                            this.errorvar = "info"
                                            this.errored = true
                                        }
                                        if (this.results.data.upstream && !this.results.data.included) {
                                            this.errormsg = "No released backports found"
                                            this.errorvar = "info"
                                            this.errored = true
                                        }
                                    })
                                    .catch(error => {
                                        console.log(error)
                                        this.errormsg = "API call failed. Maybe the API is currently not available, please try again later."
                                        this.errorvar = "danger"
                                        this.errored = true
                                    })
                                    .finally(() => this.loading = false)
                            }
                        })
                        .catch(error => {
                            console.log(error)
                            this.errormsg = "API call failed. Maybe the API is currently not available, please try again later."
                            this.errorvar = "danger"
                            this.errored = true
                            this.loading = false
                        })
                } else {
                    this.loading = false
                    this.errored = false
                    this.results = null
                }
            }
        }
    }
</script>

<style scoped>

</style>